var exports = {
  "Qs": "ChannelCreateModal.module__content___bFlaUV",
  "HW": "ChannelCreateModal.module__channelTypeSection___bFlaUV",
  "ir": "ChannelCreateModal.module__channelTypeLabel___bFlaUV",
};

module.exports = exports;
